export default __webpack_public_path__ + "static/Plain-RegularItalic-15b04dc66d60096efead3840ea7907ee.woff";